import { render, staticRenderFns } from "./GvdPublish.modal.vue?vue&type=template&id=068f471e"
import script from "./GvdPublish.modal.vue?vue&type=script&lang=ts"
export * from "./GvdPublish.modal.vue?vue&type=script&lang=ts"
import style0 from "./GvdPublish.modal.vue?vue&type=style&index=0&id=068f471e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports